module.exports = __webpack_public_path__ + "assets/img/6967651bfcd93055e49842fbb30ff0e0.png";